import React from 'react';
import apiService from '../../../services/api';
import "./CamposSolicitados.css";
import Navbar from '../../../components/layout/Navbar/Navbar';
import BemVindoComponent from '../../../components/Campos-Solicitados/BemVindoComponent';
import DashboardContent from '../../../components/Campos-Solicitados/DashboardContent';
import Status from "../../../components/Campos-Solicitados/Status";
import Sidebar from '../../../components/layout/Sidebar/Sidebar';
import { ESTABELECIMENTO_SAUDE_SIDEBAR } from '../../../constants/sidebarConfig';

const CamposSolicitados = () => {

  return (
    <div className="CamposSolicitados-Page">
      <div className="navbar">
        <Navbar onLogout={apiService.logout}/>
      </div>
      <div className="container">
        <div className="sidebar">
          <Sidebar items={ESTABELECIMENTO_SAUDE_SIDEBAR}/>
        </div>
        <div className="main-content">
          <BemVindoComponent />
          <Status />
          <DashboardContent />
        </div>
      </div>
    </div>
  );
};

export default CamposSolicitados;
